import { render, staticRenderFns } from "./PhieuChi.vue?vue&type=template&id=64cc55aa"
import script from "./PhieuChi.vue?vue&type=script&lang=js"
export * from "./PhieuChi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports